<mat-card class="no-data" [ngClass]="{'with-shadow': withShadow}" *ngIf="showAsCard">
  <mat-icon class="placeholder-icon" *ngIf="!hasAddButton">{{icon}}</mat-icon>
  <button class="add-button" mat-fab *ngIf="hasAddButton" (click)="addButtonClick.emit()" matTooltip="Hinzufügen">
    <mat-icon>add</mat-icon>
  </button>
  <h5 class="no-data-msg">{{message}}</h5>
</mat-card>
<div class="no-data" [ngClass]="{'with-shadow': withShadow,'no-background':!showAsCard}" *ngIf="!showAsCard">
  <mat-icon class="placeholder-icon" *ngIf="!hasAddButton">{{icon}}</mat-icon>
  <button class="add-button" mat-fab *ngIf="hasAddButton" (click)="addButtonClick.emit()" matTooltip="Hinzufügen">
    <mat-icon>add</mat-icon>
  </button>
  <h5 class="no-data-msg">{{message}}</h5>
</div>
